import React from 'react';

function Topfooterimage(props) {
    return (
        <div id='topfooterimg' >
            <img src="https://www.kindmeal.my/images/how_kindmeal_works.png" alt="" />
        </div>
    );
}

export default Topfooterimage;